import { InjectionToken } from '@angular/core';

export const SITE_SPECIFIC_TRAINING_PDF_REPORT_BASE: InjectionToken<string> =
  new InjectionToken('SITE_SPECIFIC_TRAINING_PDF_REPORT_BASE');
